import React from 'react';
import '../style/css/homepage.css'
import NotifhpContainer from "../comps/homepage/NotifhpContainer";
import InvitedSoonContainer from "../comps/homepage/InvitedSoonContainer";
import WaitingHPContainer from "../comps/homepage/WaitingHPContainer";
import TopNavbar from "./TopNavbar";

function HomePage() {
    return (
        <>
            <div className={'main-info-container'}>
                <div className={'home-container'}>
                    <NotifhpContainer/>
                </div>
                <div className={'home-container'}>
                    <InvitedSoonContainer/>
                </div>
                <div className={'home-container'}>
                    <WaitingHPContainer/>
                </div>
            </div>
        </>
    )
        ;
}

export default HomePage;